import services from 'services/services';

// Import types
import { PaymentMethod } from 'types/api/payments';
import type { Packet } from 'types/api/products/packets';
import { ProductType, type PacketSubtype } from 'types/api/products/product';
import type { PriceWithId } from 'types/api/prices';
import type { PacketWithPriceAndChannels } from 'types/views/configurator';

// Import helpers
import { fetchPacketList, fetchPacketProducts } from 'helpers/api/products';

const fetchPacketPrices = (uuid: string) =>
	services
		.get<PriceWithId[]>(`/products/${uuid}/prices/-1`)
		.then(({ data }) => {
			const price = data.find((price) => price.payment_method === PaymentMethod.Bluemedia_Subscription);
			return price?.id ?? null;
		})
		.catch(() => null);

const fetchPacketData = async (packet: Packet): Promise<PacketWithPriceAndChannels> => {
	const price_id = await fetchPacketPrices(packet.uuid);
	const channels = await fetchPacketProducts(packet.uuid, ProductType.Channel);
	return Object.assign({}, packet, { price_id, channels });
};

export const fetchPacketsBySubtype = async (subtype: PacketSubtype[]): Promise<PacketWithPriceAndChannels[]> =>
	await fetchPacketList({
		subtype,
		order: 'order',
		orderDir: 'asc',
		show_included_packets: true,
		show_only_products_with_prices: true
	})
		.then(async (packets) => await Promise.all(packets.map(fetchPacketData)).catch(() => []))
		.catch(() => []);
